import { IAddress } from '@ApiModels/commerceProfile';
import { IHbbWfbbProcessCheckout } from '@Redux/modules/persistentCheckoutData/actions';

export type TAddress = Pick<IAddress, 'markerPosition'>;

export const isSameAddress = (
	selectedAddress: TAddress | undefined,
	checkoutLocation: IHbbWfbbProcessCheckout | undefined
): boolean => {
	const latMatch = String(selectedAddress?.markerPosition?.lat) === String(checkoutLocation?.latitude);
	const lngMatch = String(selectedAddress?.markerPosition?.lng) === String(checkoutLocation?.longitude);
	return latMatch && lngMatch;
};
